import { FastField, useFormikContext } from 'formik';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import NumericInput from '../../../../../../components/library/inputs/numeric/NumericInput';
import SelectInput from '../../../../../../components/library/inputs/select/SelectInput';
import { DiscountModel } from '../../../../../../models/form/form';

interface Props {
  discount: DiscountModel;
  name: string;
}

const Discount: FC<Props> = ({ name }) => {
  const intl = useIntl();
  const formikContext = useFormikContext();
  const meta = formikContext.getFieldMeta(`${name}.value`);

  return (
    <div>
      <div className="d-flex d-flex-row align-items-center">
        <div>{intl.formatMessage({ id: 'paymentModes.applyDiscount' })}</div>
        <div style={{ width: 70, marginLeft: 20, marginRight: 5 }}>
          <FastField name={`${name}.value`}>
            {({ field, form }) => {
              return (
                <div>
                  <NumericInput
                    id="formName"
                    enabled={true}
                    placeholder={'-'}
                    value={field.value}
                    onChange={(event) => {
                      form.setFieldValue(field.name, event.target.value);
                    }}
                    minValue={0}
                  />
                </div>
              );
            }}
          </FastField>
        </div>
        <div style={{ width: 70 }}>
          <FastField name={`${name}.type`}>
            {({ field, form }) => {
              return (
                <SelectInput
                  onChange={(event) => {
                    form.setFieldValue(field.name, event.target.value);
                    formikContext.validateField(`${name}.value`);
                  }}
                  enabled={true}
                  noEmptyValue={true}
                  options={[
                    { text: '$', value: 'amount' },
                    { text: '%', value: 'percent' },
                  ]}
                  value={field.value || 'amount'}
                />
              );
            }}
          </FastField>
        </div>
      </div>

      {meta.touched && meta.error && <div className="feedback-invalid">{meta.error}</div>}
    </div>
  );
};

export default Discount;
